import { useEffect, useState } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Stack } from '../../../../../design-system/stack/stack';

const DELAY_BETWEEN_DOTS = 300;
const LOADING_TEXT = 'Just a moment while we read your document';

type LoadingInvoiceProps = {
  onCancel: () => void;
};

export const LoadingInvoice = ({ onCancel }: LoadingInvoiceProps) => {
  const [dots, setDots] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      // % 4 creates the sequence of dots: 0, 1, 2, 3, 0, 1, 2, 3, ...
      setDots((prev) => (prev + 1) % 4);
    }, DELAY_BETWEEN_DOTS);

    return () => clearInterval(interval);
  }, []);

  return (
    <Stack space={4} className="w-full px-40">
      <h2 className="text-3xl font-medium text-black">
        {LOADING_TEXT}
        <span className="absolute">{'.'.repeat(dots)}</span>
      </h2>

      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
    </Stack>
  );
};
